import { getOS, isIOS } from '@weike/toolkit'
import { Toast } from 'antd-mobile'
import * as qs from 'querystring'
import CryptoJS from 'crypto-js'

const opt = Object.prototype.toString

// FIXME 代码冗余
declare const WKApp: any

//页面埋点 玄武
export function setEvent(evt: string, params?: { [propname: string]: any }) {
  try {
    const source_page = sessionStorage.getItem('event_source_page') || ''
    ;(window as any).TorDataService &&
      (window as any).TorDataService.emitAction(evt, {
        ...params,
        ...(!!source_page ? { source_page } : {}),
      })
  } catch (err) {}
}

// FIXME 代码冗余
export function isLZWKAPP() {
  return /lycheer/.test(navigator.userAgent.toLocaleLowerCase())
}

// tip: 上面判断荔课APP的isLZWKAPP方法 安卓的梨花APP也会命中，改成用lihua来判断APP类型
export function isLIHUAAPP() {
  return /lihua/.test(navigator.userAgent.toLocaleLowerCase())
}

export function isLIHUAWRITEAPP() {
  return /lhwrite/.test(navigator.userAgent.toLocaleLowerCase())
}

/**
 * 是否为悟空app
 */
export function isWUKONGAPP() {
  return /wukong/.test(navigator.userAgent.toLocaleLowerCase())
}
/**
 * 是否为梨花研修院app
 */
export function isLIHUAEDUAPP() {
  return /lihuaedu/.test(navigator.userAgent.toLocaleLowerCase())
}

export const isInApp = () => {
  return (
    isLZWKAPP() ||
    isLIHUAAPP() ||
    isLIHUAWRITEAPP() ||
    isWUKONGAPP() ||
    isLIHUAEDUAPP()
  )
}

// FIXME 代码冗余
export function sharePic(opts: Record<string, any>) {
  if (isLZWKAPP()) {
    if (navigator.userAgent.toLowerCase().indexOf('android') > -1) {
      WKApp.shareImage(opts.pic)
    }
    if (navigator.userAgent.indexOf('iP') > -1) {
      // @ts-ignore
      window.webkit.messageHandlers.WKApp.postMessage({
        function: 'shareImage',
        json: {
          share_image_url: opts.pic,
        },
      })
    }
  }
}

export function TimeFormat(timestamp: number, type: string) {
  const date = new Date(timestamp * 1000)
  const Y = date.getFullYear()
  const M =
    date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  const D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  const h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  const m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()

  switch (type) {
    case 'YMD': //年-月-日
      return Y + '-' + M + '-' + D
    case 'MD': //月-日
      return M + '-' + D
    case 'MD_HM': //月-日
      return M + '-' + D + ' ' + h + ':' + m
    case 'YMD_HMS': // 月-日 时：分：秒
      return Y + '-' + M + '-' + D + ' ' + h + ':' + m + ':' + s
    case 'CN_YMD': //x年x月x日
      return Y + '年' + M + '月' + D + '日'
    case 'CN_MD': //x月x日
      return M + '月' + D + '日'
    case 'CN_YMD_HM': //x年x月x日
      return Y + '年' + M + '月' + D + '日' + ' ' + h + ':' + m
    case 'CN_MD_HM': //x月x日
      return M + '月' + D + '日' + ' ' + h + ':' + m
    case 'hm': // 时:分
      return h + ':' + m
    case '-D': //天数差
      return Math.floor(
        (timestamp * 1000 - Date.parse(new Date().toString())) /
          1000 /
          3600 /
          24,
      )
    case '-H': //小时差
      return Math.ceil(
        (timestamp * 1000 - Date.parse(new Date().toString())) / 1000 / 3600,
      )
    default:
      //年-月-日 时:分
      return Y + '-' + M + '-' + D + ' ' + h + ':' + m
  }
}

export function getQuery<T extends { [key: string]: string }>() {
  const query = window.location.search.substring(1)
  return (query ? qs.parse(query) : {}) as T
}

export function captureRef<T>(value: T, setValue: (value: T) => any) {
  return (ref: any) => {
    if (ref && ref !== value) {
      setValue(ref)
    }
  }
}

export function isSafari() {
  const ua = window && window.navigator && window.navigator.userAgent
  return /safari\/([^\s;]*)/gi.test(ua) && !/Chrome/.test(ua) && !/QQ/.test(ua)
}

export function isWeibo() {
  const ua = window && window.navigator && window.navigator.userAgent
  return ua.indexOf('Weibo') > -1
}

export function isOverTopIOS9() {
  const ua = window && window.navigator && window.navigator.userAgent
  let version = ''
  if (isIOS()) {
    const regStr_saf = /os [\d._]*/gi
    const verinfo = ua.match(regStr_saf)
    version = (verinfo + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.')
  }
  const version_str = version + ''
  if (version_str != 'undefined' && version_str.length > 0) {
    return parseInt(version) >= 8
  } else {
    return false
  }
}

/**
 * @description  使用省略号进行内容截断，如果内容长度不够则什么也不做
 * @param str 需要处理的字符串
 * @param len 当字符串超过这个长度，后面的内容将被替换成"..."
 * @return 处理后的字符串
 */
export function subStringByEllipsis(str: string, len: number): string {
  if (len <= 0) throw new Error('len can not be less than zero!')

  if (str === null || str === undefined || str === '') return ''
  if (str.length > len) return str.substring(0, len) + '...'

  return str
}

/**
 * 获取 url 中的参数传值
 *
 * @param {string} name
 * @returns {(string | null)}
 */
export function getQueryParameter(name: string): string | null {
  const query = window.location.search.substring(1)
  const vars = query.split('&')
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=')
    if (decodeURIComponent(pair[0]) === name) {
      return decodeURIComponent(pair[1])
    }
  }
  return null
}

export function setRem(n: any): void {
  const e = n.document,
    t = e.documentElement,
    i = 375,
    d = i / 50,
    o = 'orientationchange' in n ? 'orientationchange' : 'resize',
    a = function() {
      let n = t.clientWidth || 320
      n > 375 && (n = 375)
      t.style.fontSize = n / d + 'px'
      e.body.style.fontSize = '16px'
    }
  if (e.addEventListener) {
    n.addEventListener(o, a, !1)
    e.addEventListener('DOMContentLoaded', a, !1)
  }
  a()
}

export function removeRem(n: any): void {
  const e = n.document,
    t = e.documentElement,
    o = 'orientationchange' in n ? 'orientationchange' : 'resize',
    a = function() {
      t.style.fontSize = ''
      e.body.style.fontSize = ''
    }
  if (e.addEventListener) {
    n.addEventListener(o, a, !1)
    e.addEventListener('DOMContentLoaded', a, !1)
  }
  a()
}

/**
 * 使用腾讯数据万象进行图片压缩，替换相应后缀。 （图片是腾讯云托管的才生效，  非腾讯云的无副作用）
 * @param imgSrc
 * @param width
 * @param height
 */
export const replaceCompressed = (
  imgSrc: string,
  width: string | number,
  height: string | number,
) => {
  if (!imgSrc) {
    return imgSrc
  }
  // 校验宽度，高度是否符合要求，不符合返回原来的图像链接
  if (!width || !height) {
    return imgSrc
  }
  const _WIDTH = (width + '').replace('px', '')
  const _HEIGHT = (height + '').replace('px', '')

  if (isNaN(Number(_WIDTH)) || isNaN(Number(_HEIGHT))) {
    return imgSrc
  }

  return `${imgSrc.replace(
    /[\\/-]picmsg420/,
    '',
  )}?imageView2/1/w/${_WIDTH}/h/${_HEIGHT}`
}

export function parseError(e: any) {
  const handle = () => {
    if (!e) {
      return e
    }
    if (e.tips || e.message || e.msg) {
      return e.tips || e.message || e.msg
    }
    try {
      return JSON.stringify(e)
    } catch (_) {
      return e
    }
  }

  const result = handle()
  try {
    if (result && result.toLowerCase().indexOf('network') !== -1) {
      return '网络错误'
    }
    return result
  } catch (e) {
    return result
  }
}

export function copyLink(link: string) {
  Toast.loading('复制中', 3)
  const input = document.createElement('input')
  input.setAttribute('value', link)
  document.body.appendChild(input)
  //选中文本
  input.select()
  input.setSelectionRange(0, input.value.length)
  input.setAttribute('readonly', 'readonly')
  //判断是否支持copy
  if (document.execCommand('copy')) {
    document.execCommand('copy')
    input.blur()
  }
  document.body.removeChild(input)
  Toast.success('复制成功', 3)
}

export function formatSecond(curTime: number) {
  const second = curTime % 60
  const minute = Math.floor(curTime / 60) % 60
  const hour = Math.floor(curTime / 3600) % 24
  return [hour, minute, second].map(item => (+item < 10 ? `0${item}` : item))
}

export const setHistoryState = (params: {
  [key: string]: string | undefined | null | number | boolean
}) => {
  const newUrl = `${window.location.pathname}?${qs.stringify(params)}`
  window.history.replaceState({}, '', newUrl)
}

export const updateHistoryState = (params: {}) => {
  const newParams: {
    [key: string]: string | undefined | null | number | boolean
  } = {
    ...getQuery(),
    ...params,
  }
  const keys = Object.keys(newParams)
  keys.forEach(key => {
    if (newParams[key] === undefined || newParams[key] === null) {
      delete newParams[key]
    }
  })
  setHistoryState(newParams)
}

// 视频时长格式转换  秒转分
export const calcDuration = (duration: number) => {
  if (duration >= 60) {
    const remain = duration % 60
    return `${Math.floor(duration / 60)}:${
      remain >= 10 ? remain : '0' + remain
    }`
  } else {
    return `00:${duration >= 10 ? duration : '0' + duration}`
  }
}

export const checkPhoneNumber = (num: string) => {
  return /^1[3-9]\d{9}$/.test(num)
}

function getObjectType(obj: any) {
  const objectType = Object.prototype.toString.call(obj)

  return objectType
}
export function isObject(obj: any): obj is { [key: string]: any } {
  return opt.call(obj) === '[object Object]'
}

export function isArray(obj: any) {
  const objectType = getObjectType(obj)
  // 是否为数组
  return objectType === '[object Array]'
}

export function isUndefined(obj: any): obj is undefined {
  return obj === undefined
}

export function maskPhoneNumber(phoneNumber: string) {
  if (!phoneNumber) {
    return ''
  }
  return phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
}

/**
 * 获取 lihua app 版本
 */
export function getLihuaIosAppVersion() {
  try {
    const match = navigator.userAgent.match(/LiHua\/(\d+\.\d+\.\d+)/)
    if (match) {
      return match[1]
    } else {
      return null
    }
  } catch (e) {
    console.log('getLihuaIosAppVersion', e)
    return null
  }
}

/**
 * 比较两个版本号的大小， 格式为 xx.xx.xx
 * 例如 v1 = 2.60.0, v2 = 2.70.0 则返回-1
 * v1 大于 v2 返回 1
 * v1 小于 v2 返回 -1
 * v1 等于 v2 返回 0
 * @param v1
 * @param v2
 */
export function compareVersion(v1: string, v2: string) {
  const v1Arr = (v1 || '').split('.')
  const v2Arr = (v2 || '').split('.')

  const len = Math.max(v1Arr.length, v2Arr.length)
  for (let i = 0; i < len; i++) {
    const v1N = parseInt(v1Arr[i]) || 0
    const v2N = parseInt(v2Arr[i]) || 0
    if (v1N > v2N) {
      return 1
    }
    if (v1N < v2N) {
      return -1
    }
  }

  return 0
}

/**
 * 是否支持 APP 方法
 */
export function isSupportAppMethod(method: string, supportVersion: string) {
  if (!(window as any).LHAPP) {
    return false
  }
  try {
    if (getOS() === 'ios') {
      const currentVersion = getLihuaIosAppVersion()
      if (!currentVersion) return false
      return compareVersion(currentVersion, supportVersion) >= 0
    }
    return method in window.LHAPP
  } catch (e) {
    console.error(method, e)
    return false
  }
}

/**
 * aes加密
 * @param keyStr
 * @param plaintextStr
 */
export function aesEcb128Encrypt(keyStr: string, plaintextStr: string) {
  const keyBytes = CryptoJS.enc.Utf8.parse(keyStr)
  return CryptoJS.AES.encrypt(plaintextStr, keyBytes, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).toString()
}

/**
 * 判断是否应该隐藏分享功能
 *
 * 隐藏条件：
 * 1. 梨花声音研修院APP（全局隐藏）
 * 2. 高风险直播间（国学店铺等特定直播间）
 */
export const getIsHideShareButton = (
  liveroomId: number | undefined | null,
): boolean => {
  try {
    // 安全获取高风险直播间列表
    const highRiskLiveroomIds =
      (window.WKLink && window.WKLink.highRiskLiveroomIds) || []

    // 检查是否为梨花声音研修院APP
    const isLihuaEduApp = isLIHUAEDUAPP()

    // 检查是否为高风险直播间
    const isHighRiskRoom = Boolean(
      liveroomId &&
        Array.isArray(highRiskLiveroomIds) &&
        highRiskLiveroomIds.includes(liveroomId),
    )
    console.log('isHideShareButton', isLihuaEduApp || isHighRiskRoom)
    return isLihuaEduApp || isHighRiskRoom
  } catch (error) {
    // 发生错误时记录日志，并默认返回false（不隐藏分享功能）
    return false
  }
}
export function hasParams(url: string) {
  return url.indexOf('?') > -1
}
/**
 * 往url上添加参数，会忽略值为undefined的key
 * @param url
 * @param params
 */
export function addParams(url: string, params: { [key: string]: any }) {
  const query = Object.keys(params)
    .filter(k => {
      const v = params[k] !== undefined
      if (!v) {
        console.warn('addParams key:' + k + ',value = undefined, 已自动忽略')
      }
      return v
    })
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&')
  if (!query) {
    return url
  }
  return `${url}${query && hasParams(url) ? '&' : '?'}${query}`
}

export function getSessionAccount() {
  return (
    (window.Session &&
      window.Session.sessionData &&
      window.Session.sessionData.account) ||
    {}
  )
}

/**
 * 安全获取对象深层属性值
 * @param obj - 目标对象
 * @param path - 属性路径，支持 'a.b.c' 或 ['a', 'b', 'c'] 格式
 * @param defaultValue - 默认值（可选）
 * @returns 属性值或默认值
 * @example
 * safeGet({ a: { b: { c: 1 } } }, 'a.b.c') // 1
 * safeGet({ a: { b: {} } }, 'a.b.c', 'default') // 'default'
 * safeGet(null, 'a.b.c', []) // []
 */
export function safeGet<T = any>(
  obj: any,
  path: string | string[],
  defaultValue?: T,
): T {
  if (obj == null) {
    return defaultValue as T
  }

  const keys = Array.isArray(path) ? path : path.split('.')
  let result = obj

  for (const key of keys) {
    if (result == null) {
      return defaultValue as T
    }
    result = result[key]
  }

  return result === undefined ? (defaultValue as T) : result
}

/**
 * 将 base64 字符串（可带 data URL 前缀）转为 File，用于 COS 等上传
 * @param base64 base64 或 data:image/xxx;base64,xxx 格式
 * @param filename 文件名，默认 'image.png'
 */
export function base64ToFile(base64: string, filename = 'image.png'): File {
  const dataUrl = base64.startsWith('data:')
    ? base64
    : `data:image/png;base64,${base64}`
  const arr = dataUrl.split(',')
  const mime = (arr[0].match(/:(.*?);/) || [])[1] || 'image/png'
  const bstr = atob(arr[1] || '')
  const u8arr = new Uint8Array(bstr.length)
  for (let i = 0; i < bstr.length; i += 1) {
    u8arr[i] = bstr.charCodeAt(i)
  }
  return new File([u8arr], filename, { type: mime })
}
